export default "/kiban/_next/static/images/on-10fd8a94dfa77265275cb4bcc14707f9.png";